import { atom } from 'jotai'

/**
 * 配車板の横スクロール位置から算出した「現在表示中の日付」。
 * 未配車リストの発送日フィルタに使用する。
 * undefined の場合はページの shippingDate をフォールバックする。
 */
export const scrollVisibleDateAtom = atom<string | undefined>(undefined)
